<div class="login-wrapper signup-wrapper d-flex align-items-center">
  <div class="auth-img">
    <img src="assets/images/login.png" alt="" class="he" />
  </div>
  <div class="auth-login">
    <ng-container *ngIf="otpSent == false; else sentOtpBlock">
      <div class="signup-title mt-3">
        <h1>Signup!</h1>
      </div>
      <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="changeSignupTab($event)"
        mat-align-tabs="center">
        <mat-tab label="as Coach">
          <div class="log-title mt-3">
            <!-- <h1>Signup!</h1> -->
            <p>Please include all requested information.</p>
          </div>

          <form [formGroup]="registerForm">
            <div class="row form-scroll">
              <!-- First Name -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter your First Name"
                    formControlName="first_name" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'first_name')
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'first_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- Last Name -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter your Last Name" formControlName="last_name"
                    [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'last_name')
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'last_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- Email Address -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter your Email address" formControlName="email"
                    [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'email')
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'email',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(registerForm, 'email', 'email')
                    ">
                    <div>Please enter a valid email</div>
                  </div>
                </div>
              </div>

              <!-- Phone Number -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter your Phone no" formControlName="phone"
                    [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'phone')
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'phone',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'phone',
                        'pattern'
                      ) ||
                      !Global.isInputRuleValid(
                        registerForm,
                        'phone',
                        'minlength'
                      ) ||
                      !Global.isInputRuleValid(
                        registerForm,
                        'phone',
                        'maxlength'
                      )
                    ">
                    <div>Please enter a valid phone no</div>
                  </div>
                </div>
              </div>

              <!-- School -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="School name" [items]="schoolMaster" bindLabel="school_name" bindValue="_id"
                    formControlName="school_name" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'school_name')
                    " [addTag]="newMasterValueEntered.bind(this, 'school')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'school_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- City of School -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="City of School" [items]="cityMaster" bindLabel="city_name" bindValue="_id"
                    formControlName="city_name" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'city_name')
                    " [addTag]="newMasterValueEntered.bind(this, 'city')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'city_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- State of School -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="State of School" [items]="stateMaster" bindLabel="state_name" bindValue="_id"
                    formControlName="state_name" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'state_name')
                    " [addTag]="newMasterValueEntered.bind(this, 'state')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'state_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- CIF Section -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="CIF Section" [items]="sectionMaster" bindLabel="section_name" bindValue="_id"
                    formControlName="section_name" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'section_name')
                    " [addTag]="newMasterValueEntered.bind(this, 'section')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'section_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <ng-container formArrayName="items">
                <ng-container *ngFor="let item of items.controls; let i = index" [formGroupName]="i">
                  <div class="row">
                    <!-- Sport -->
                    <!-- Name of Sport -->
                    <div class="col-lg-6 input-pad">
                      <div class="mb-4">
                        <ng-select placeholder="Name of Sport" [items]="sportMaster" bindLabel="sport_name"
                          bindValue="_id" formControlName="sport" [class.is-invalid]="
                            item.get('sport')?.invalid &&
                            (item.get('sport')?.touched ||
                              item.get('sport')?.dirty)
                          "></ng-select>

                        <div class="invalid-feedback" *ngIf="
                            item.get('sport')?.invalid &&
                            (item.get('sport')?.touched ||
                              item.get('sport')?.dirty)
                          ">
                          <div>This field is required</div>
                        </div>
                      </div>
                    </div>

                    <!-- Level -->
                    <!-- Sports Level -->
                    <div class="col-lg-6 input-pad">
                      <div class="mb-4">
                        <div class="d-flex align-items-center">
                          <!-- ng-select with 75% width -->
                          <ng-select class="flex-grow-1 me-2" style="flex: 0 0 75%;" placeholder="Sports Level"
                            [items]="levelMaster" bindLabel="level_name" bindValue="_id" formControlName="level"
                            [class.is-invalid]="
                            item.get('level')?.invalid &&
                            (item.get('level')?.touched || item.get('level')?.dirty)
                          ">
                          </ng-select>

                          <!-- button takes remaining space -->
                          <button mat-stroked-button color="warn" type="button" (click)="removeItem(i)" *ngIf="i > 0"
                            style="flex: 0 0 25%;">
                            Remove
                          </button>
                        </div>

                        <!-- Validation -->
                        <div class="invalid-feedback" *ngIf="
        item.get('level')?.invalid &&
        (item.get('level')?.touched || item.get('level')?.dirty)
      ">
                          <div>This field is required</div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- Add More Button in the Middle -->
                  <div class="d-flex justify-content-center mb-3" *ngIf="i == items.controls.length - 1">
                    <button mat-raised-button color="primary" type="button" (click)="addRequest()">
                      + Add More
                    </button>
                  </div>
                </ng-container>
              </ng-container>

              <!-- Zipcode -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Zipcode" formControlName="zip_code"
                    [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'zip_code')
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'zip_code',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- Rating -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <!-- <ng-select
                    placeholder="Rating"
                    [items]="ratingMaster"
                    bindLabel="rating_name"
                    bindValue="_id"
                    formControlName="rating"
                    [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'rating')
                    "
                  ></ng-select> -->
                  <ng-select placeholder="Varsity Only Rating" formControlName="rating" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'rating')
                    ">
                    <ng-option *ngFor="let rating of ratingMaster" [value]="rating._id">{{
                      rating.rating_name +
                      " " +
                      rating.rating_value +
                      " " +
                      rating.description
                      }}</ng-option>
                  </ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'rating',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- League / Conference -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="League / Conference" formControlName="league"
                    [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'league')
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'league',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- Division -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="Division" [items]="divisionMaster" bindLabel="division_name" bindValue="_id"
                    formControlName="division" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'division')
                    "></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'division',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- Password -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="password" class="form-control" placeholder="Password" formControlName="password"
                    [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'password')
                    " autocomplete="new-password" />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password',
                        'minlength'
                      )
                    ">
                    <div>The password should be minimum 8 characters</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password',
                        'maxlength'
                      )
                    ">
                    <div>The password should be maximum 20 characters</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password',
                        'pattern'
                      )
                    ">
                    <div>
                      The password must include Upper Case, Lower Case, Number,
                      Symbol
                    </div>
                  </div>
                </div>
              </div>

              <!-- Password Confirmation -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="password" class="form-control" placeholder="Password Confirmation"
                    formControlName="password_confirmation" [class.is-invalid]="
                      !Global.isInputValid(
                        registerForm,
                        'password_confirmation'
                      )
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password_confirmation',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password_confirmation',
                        'minlength'
                      )
                    ">
                    <div>The password should be minimum 8 characters</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password_confirmation',
                        'maxlength'
                      )
                    ">
                    <div>The password should be maximum 20 characters</div>
                  </div>
                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerForm,
                        'password_confirmation',
                        'pattern'
                      )
                    ">
                    <div>
                      The password must include Upper Case, Lower Case, Number,
                      Symbol
                    </div>
                  </div>
                </div>
              </div>
              <!-- Coupon Code -->
              <div class="col-lg-12 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Coupon Code (Optional)"
                    formControlName="coupon_code" [class.is-invalid]="
                      !Global.isInputValid(registerForm, 'coupon_code')
                    " />
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Submit Button -->
              <div class="col-lg-12 input-pad">
                <button mat-button type="submit" (click)="submitRegister($event)">
                  <span class="indicator-label">Signup Now!</span>
                  <span class="indicator-progress">Please wait...
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
              </div>
            </div>
          </form>
        </mat-tab>
        <mat-tab label="as AthleticDirector">
          <div class="log-title mt-3">
            <p>Please include all requested information.</p>
          </div>
          <form [formGroup]="registerAthleticDirectorForm">
            <div class="row form-scroll">
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter your First Name"
                    formControlName="first_name" [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'first_name'
                      )
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'first_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <!-- Last Name -->
              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter your Last Name" formControlName="last_name"
                    [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'last_name'
                      )
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'last_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter Email address" formControlName="email"
                    [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'email'
                      )
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'email',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'email',
                        'email'
                      )
                    ">
                    <div>Please enter a valid email</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Enter Phone no" formControlName="phone"
                    [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'phone'
                      )
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'phone',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'phone',
                        'pattern'
                      ) ||
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'phone',
                        'minlength'
                      ) ||
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'phone',
                        'maxlength'
                      )
                    ">
                    <div>Please enter a valid phone no</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="School name" [items]="schoolMaster" bindLabel="school_name" bindValue="_id"
                    formControlName="school_name" [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'school_name'
                      )
                    " [addTag]="newMasterValueEntered.bind(this, 'school')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'school_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="City of School" [items]="cityMaster" bindLabel="city_name" bindValue="_id"
                    formControlName="city_name" [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'city_name'
                      )
                    " [addTag]="newMasterValueEntered.bind(this, 'city')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'city_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="State of School" [items]="stateMaster" bindLabel="state_name" bindValue="_id"
                    formControlName="state_name" [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'state_name'
                      )
                    " [addTag]="newMasterValueEntered.bind(this, 'state')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'state_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <ng-select placeholder="CIF Section" [items]="sectionMaster" bindLabel="section_name" bindValue="_id"
                    formControlName="section_name" [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'section_name'
                      )
                    " [addTag]="newMasterValueEntered.bind(this, 'section')"></ng-select>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'section_name',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Zipcode" formControlName="zip_code"
                    [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'zip_code'
                      )
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'zip_code',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="password" class="form-control" placeholder="Password" formControlName="password"
                    [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'password'
                      )
                    " autocomplete="new-password" />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password',
                        'minlength'
                      )
                    ">
                    <div>The password should be minimum 8 characters</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password',
                        'maxlength'
                      )
                    ">
                    <div>The password should be maximum 20 characters</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password',
                        'pattern'
                      )
                    ">
                    <div>
                      The password must include Upper Case, Lower Case, Number,
                      Symbol
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="password" class="form-control" placeholder="Password Confirmation"
                    formControlName="password_confirmation" [class.is-invalid]="
                      !Global.isInputValid(
                        registerAthleticDirectorForm,
                        'password_confirmation'
                      )
                    " />

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password_confirmation',
                        'required'
                      )
                    ">
                    <div>This field is required</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password_confirmation',
                        'minlength'
                      )
                    ">
                    <div>The password should be minimum 8 characters</div>
                  </div>

                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password_confirmation',
                        'maxlength'
                      )
                    ">
                    <div>The password should be maximum 20 characters</div>
                  </div>
                  <div class="invalid-feedback" *ngIf="
                      !Global.isInputRuleValid(
                        registerAthleticDirectorForm,
                        'password_confirmation',
                        'pattern'
                      )
                    ">
                    <div>
                      The password must include Upper Case, Lower Case, Number,
                      Symbol
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 input-pad">
                <div class="mb-4">
                  <input type="text" class="form-control" placeholder="Coupon Code" formControlName="coupon_code" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 input-pad">
                <button mat-button type="submit" (click)="submitRegisterAthleticDirector($event)">
                  <span class="indicator-label">Signup Now!</span>
                  <span class="indicator-progress">Please wait...
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
              </div>
            </div>
          </form>
        </mat-tab>
      </mat-tab-group>
    </ng-container>

    <ng-template #sentOtpBlock>
      <app-otp-verification [queryParams]="queryParams" [emailToVerify]="emailToVerify"
        (onVerificationAction)="otpVerificationAction($event)">
      </app-otp-verification>
    </ng-template>

    <div class="f-group text-center mt-4">
      <p>
        Alreay have an account?
        <a routerLink="/login" [queryParams]="{ tab: queryParams }">Login</a>
      </p>
    </div>

    <ng-template #sentOtpBlock>
      <app-otp-verification [emailToVerify]="this.registerForm.get('email')?.value"
        (onVerificationAction)="otpVerificationAction($event)">
      </app-otp-verification>
    </ng-template>

    <div class="login-footer d-flex align-items-center">
      <p>
        <a target="_blank" routerLink="/privacy-and-policy">Privacy Policy</a>
        <a target="_blank" routerLink="/terms-and-condition">Terms & Conditions</a>
      </p>
      <p class="ms-auto">
        <a routerLink="/">{{ Global.APP_NAME }}</a> {{ Global.CURRENT_YEAR }} |
        All Rights Reserved
      </p>
    </div>
  </div>
</div>
